import { render, staticRenderFns } from "./AddBanners.vue?vue&type=template&id=4d20725f&scoped=true&"
import script from "./AddBanners.vue?vue&type=script&lang=js&"
export * from "./AddBanners.vue?vue&type=script&lang=js&"
import style0 from "./AddBanners.vue?vue&type=style&index=0&id=4d20725f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d20725f",
  null
  
)

export default component.exports